import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";

const CurrentInjury2 = () => {
  const history = useHistory();

  const initialValues = {
    injuries: [],
    consciousness: "No",
    memoryBefore: "No",
    memoryAfter: "No",
    neckPain: "No",
  };

  const injuryOptions = [
    "Lying motionless",
    "Falling unprotected to the ground",
    "Impact seizure",
    "Balance/gait difficulties",
    "Disorientation/confusion",
    "Blank/vacant look",
  ];

  const handleSubmit = (values) => {
    console.log("Form Values:", values);
    history.push("/concussion-forms/add/9");
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <span className="form-title">Current Injury</span>
        <span className="form-progress">8/12</span>
      </div>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form className="form-wrapper">
            <div className="form-content">
              <div className="field-wrapper">
                <label className="field-label">
                  Immediately following the injury, did anyone witness:
                </label>
                <div role="group" aria-labelledby="checkbox-group">
                  {injuryOptions.map((option, index) => (
                    <label key={index} className="option-label">
                      <Field
                        type="checkbox"
                        name="injuries"
                        value={option}
                        className="checkbox-input"
                      />
                      {option}
                    </label>
                  ))}
                </div>

                <ErrorMessage
                  name="injuries"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Do you lose consciousness?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="consciousness">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("consciousness", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="consciousness"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Do you have trouble remembering the events BEFORE the injury?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="memoryBefore">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("memoryBefore", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="memoryBefore"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="field-wrapper">
                <label className="field-label">
                  Do you have trouble remembering the events AFTER the injury?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="memoryAfter">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("memoryAfter", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="memoryAfter"
                  component="div"
                  className="error-message"
                />
              </div>
              <div className="field-wrapper">
                <label className="field-label">
                  Do you have neck pain since the injury?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="neckPain">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() => form.setFieldValue("neckPain", option)}
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="neckPain"
                  component="div"
                  className="error-message"
                />
              </div>
            </div>

            <div className="btn-wrapper">
              <button
                type="button"
                className="form-btns back-btn"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                BACK
              </button>
              <button
                type="submit"
                className="form-btns next-btn"
                disabled={isSubmitting}
              >
                NEXT
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CurrentInjury2;
